import { render, staticRenderFns } from "./CwcPortalMenu.vue?vue&type=template&id=1ef3dcf0"
import script from "./CwcPortalMenu.vue?vue&type=script&lang=js"
export * from "./CwcPortalMenu.vue?vue&type=script&lang=js"
import style0 from "./CwcPortalMenu.vue?vue&type=style&index=0&id=1ef3dcf0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports